import React from "react";
import { NavigationalButtons } from "./CreateCourseWizard";
import { Form, Formik,ErrorMessage  } from "formik";
import useAxios from "axios-hooks";
import ChoiceGroup from "../../../../Forms/ChoiceGroup";
import { DatePicker, TimePicker } from "@fluentui/react";
import * as Yup from "yup"; 
import { Spinner } from "@fluentui/react";
import Toast from "../../../../Forms/Toast";

const PublishStatusStep = ({ courseId, nextOnClick, prevOnClick }) => {
    const [{ data: course, loading }] = useAxios(`courses/${courseId}`);
    const [showToast, setShowToast] = React.useState(false);
    const [, postForm] = useAxios(
        {
            url: `/courses/${courseId}/publish-status`,
            method: "put",
        },
        { manual: true }
    );

    const [{ data: statusOptions }] = useAxios("courses/publish-statuses");

    const validationSchema = Yup.object().shape({
        crsPublishStatusId: Yup.number().required("Publish status is required"),
        publishDateTime: Yup.date().nullable().when("crsPublishStatusId", {
            is: 2, // When the status ID is 2
            then: Yup.date().required("Publish DateTime is required"), // Make it required
            otherwise: Yup.date().nullable(),
        }),
        lastUpdatedDate: Yup.date().required("Last updated date is required"),
        lastUpdatedTime: Yup.date().required("Last updated time is required"),
    });

    if (loading)
        return <Spinner className="absolute-center" label="Loading data..." />;
    return (
        <div style={{width:300}}>
            <Formik
                initialValues={{
                    crsPublishStatusId: course.statusId,
                    publishDateTime: course.publishDate ? new Date(course.publishDate.replace("Z","")) : null,
                    lastUpdatedDate: course.lastUpdatedDate ? new Date(course.lastUpdatedDate.replace("Z","")) : null,
                    lastUpdatedTime: course.lastUpdatedDate
                        ? new Date(course.lastUpdatedDate.replace("Z","")) // Valid `Date` object for `TimePicker`
                        : new Date(), // Default to the current date/time
                }}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                    const lastUpdatedDate = new Date(values.lastUpdatedDate);
                    // Combine lastUpdatedDate with time values
                    lastUpdatedDate.setHours(values.lastUpdatedTime.getHours());
                    lastUpdatedDate.setMinutes(values.lastUpdatedTime.getMinutes());
                    const result = await postForm({
                        data: {
                            CRSID: parseInt(courseId),
                            CRSPublishStatusID: values.crsPublishStatusId,
                            PublishDateTime: values.publishDateTime,
                            LastUpdatedDate: lastUpdatedDate,
                        },
                    });

                    if (!result.isAxiosError) {
                        setShowToast(true);
                    }
                }}
            >
                {({ setFieldValue, values }) => (
                    <Form>
                        <>
                            <ChoiceGroup
                                label="Publish Status"
                                name="crsPublishStatusId"
                                options={
                                    statusOptions &&
                                    statusOptions.map((status) => ({
                                        key: status.id,
                                        text: status.name,
                                    }))
                                }
                            />
                            <ErrorMessage name="crsPublishStatusId" component="div" className="error-message" />
                            <DatePicker
                                label="Publish Date"
                                className="mt20"
                                value={values.publishDateTime}
                                onSelectDate={(date) => setFieldValue("publishDateTime", date)}
                                allowTextInput
                            />
                           <ErrorMessage name="publishDateTime" component="div" className="error-message" />
                            <div className="displayflex">
                                <DatePicker
                                    label="Last Updated Date"
                                    style={{flex:1}}
                                    value={values.lastUpdatedDate}
                                    onSelectDate={(date) => setFieldValue("lastUpdatedDate", date)}
                                    allowTextInput
                                />
                                <TimePicker
                                    style={{width:80, marginTop:29, marginLeft:5}}
                                    value={values.lastUpdatedTime} // Ensure this is a Date object
                                    onChange={(_, time) => {
                                        if (time) {
                                            // Directly update `lastUpdatedTime` with the new Date object
                                            setFieldValue("lastUpdatedTime", time);
                                        }
                                    }}
                                    allowFreeform
                                />
                            </div>
                            <ErrorMessage name="lastUpdatedDate" component="div" className="error-message" />
                            <ErrorMessage name="lastUpdatedTime" component="div" className="error-message" />
                        </>
                        <NavigationalButtons
                            onNextProps={{ type: "submit", text: "Save and Continue" }}
                            onPrevHandler={prevOnClick}
                        />
                    </Form>
                )}
            </Formik>
            <Toast show={showToast} message="Course Saved" onClose={()=>setShowToast(false)}/>
        </div>
    );
};

export default PublishStatusStep;
